import React from 'react';
import './Resume.css';
import resumePDF from './../assets/kuan_resume.pdf'; // Add your resume file to the assets folder

export function Resume() {
  return (
    <div className="resume">
      <div className="resume__viewer">
        <embed src={resumePDF} type="application/pdf" width="100%" height="800px" />
      </div>
    </div>
  );
}